import { useState, useCallback } from 'react';
import { useInjection } from '../../../di_container/InjectionProvider';
import { DateHelper } from '../../../common/helper';
export const useReceipt = () => {
    const { container } = useInjection();
    const [loading, setLoading] = useState(false);
    const columns = [
        { id: 'date', label: '日付', minWidth: 80 },
        { id: 'content', label: 'タイトル', minWidth: 150 },
        { id: 'amount', label: '金額', minWidth: 80 },
    ];
    /**
     * 領収書一覧を取得する
     */
    const loadReceipts = useCallback(async (limit, startingAfterId) => {
        setLoading(true);
        try {
            const imoryRepository = container.resolve('ImoryApiRepository');
            const result = await imoryRepository.loadReceipts(limit, startingAfterId);
            setLoading(false);
            if (result.data === undefined) {
                return [];
            }
            return result.data.data.map((item) => {
                const dateAt = new Date(DateHelper.toMillisecondFromSecond(item.createdAt));
                return {
                    date: DateHelper.toStringDateOnly(dateAt),
                    content: item.description !== null ? item.description : '',
                    amount: item.amount.toLocaleString(),
                    id: item.id,
                    dateAt: dateAt,
                };
            });
        }
        catch (e) {
            console.error('error', e);
            setLoading(false);
            throw e;
        }
    }, []);
    return { columns, loading, loadReceipts };
};
